const API = {
    USER_MANAGEMENT_API_BASE_URL: process.env.REACT_APP_USER_MANAGEMENT_API_BASE_URL,
    USER_SIGNUP_URL: '/v1/auth/signup',
    USER_LOGIN_URL: '/v1/auth/login',
    RESEND_VERFICATION_EMAIL: '/v1/auth/verify-email',
    VERIFY_OTP: "/v1/auth/verify-otp",
    FORGOT_PASSWORD: '/v1/auth/forgot-password',
    RESET_PASSWORD_OTP_VERFICATION: '/v1/auth/reset-password-otp',
    REFRESH_TOKEN:'/v1/auth/refresh-token',
    RESET_PASSWORD: '/v1/auth/reset-password',
    GET_ADS: '/v1/ads/user?filter=All',
    MARKET_PLACE: '/market-place',
    HEALTH_TRACKER: '/health-tracker',
    CREATE_ADS: '/v1/ads/create',
    DELETE_ADS: '/v1/ads',
    UPDATE_ADS: '/v1/ads/update',
    GET_WISHLIST: '/v1/wishlist',
    PROFILE_DETAILS: '/v1/profile',
    CAMPUS_LIST: '/v1/campus-list',
    DELETE_ACC:'/v1/delete-account',
    GET_APPOINMENTS: '/v1/appointments',
    GET_CLASSES: '/v1/classes',
    TOOLS: '/tools',
    EXTRA_CLASSES: '/v1/extra-class',
    STUDY_GROUP:'/v1/studygroup',
    GOALS: '/v1/health/goals',
    COMMUNITY: '/community',
    EVENT: '/v1/events',
    HEALTH_DATA: '/v1/healthdata',
    CALENDAR_EVENTS: '/community/v1/calendar'

}
export default API;